import { render, staticRenderFns } from "./ReportProblemButton.vue?vue&type=template&id=e0d294b0&scoped=true&"
import script from "./ReportProblemButton.vue?vue&type=script&lang=js&"
export * from "./ReportProblemButton.vue?vue&type=script&lang=js&"
import style0 from "./ReportProblemButton.vue?vue&type=style&index=0&id=e0d294b0&lang=scss&scoped=true&"
import style1 from "./ReportProblemButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d294b0",
  null
  
)

export default component.exports